<div class="chat-share-modal">
  <app-share-card *ngIf="previewCard" [card]="previewCard" mode="preview"></app-share-card>

  <div class="chat-share-modal__field">
    <label>{{ 'shared.share.chat.recipients' | translate }}</label>
    <ng-container *ngIf="!isFullscreenRecipientLayout; else mobileRecipients">
      <p-autoComplete
        #desktopRecipientsAutocomplete
        [suggestions]="desktopRecipientSuggestions"
        [(ngModel)]="desktopAutocompleteValue"
        [multiple]="true"
        [dropdown]="true"
        [delay]="250"
        [minLength]="0"
        [emptyMessage]="'common.no_results' | translate"
        appendTo="body"
        [optionLabel]="'alias'"
        [placeholder]="'shared.share.chat.recipients_placeholder' | translate"
        (completeMethod)="onRecipientSearch($event)"
        (onFocus)="onRecipientFocus()"
        (onSelect)="onRecipientSelected($event)">
        <ng-template let-option pTemplate="item">
          <div class="chat-share-modal__recipient">
            <app-thumbnail
              [imgSrc]="recipientAvatar(option) | mediaObject:{defaultImageType: 'avatar'}"
              [circle]="true"
              size="sm">
            </app-thumbnail>
            <span class="chat-share-modal__recipient-label">{{ option.alias }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="loadingicon">
          <span class="app-loading-ring" aria-hidden="true"></span>
        </ng-template>
      </p-autoComplete>
    </ng-container>

    <ng-template #mobileRecipients>
      <input
        pInputText
        type="text"
        class="w-full"
        [value]="currentRecipientQuery"
        [placeholder]="'common.choose_or_search' | translate"
        (focus)="onRecipientFocus()"
        (input)="onMobileRecipientSearch($event)"
      />

      <div
        #mobileRecipientScroller
        class="chat-share-modal__recipient-list"
        (scroll)="onMobileResultsScroll()">
        <button
          *ngFor="let option of recipientResults"
          type="button"
          class="chat-share-modal__recipient-row"
          [class.chat-share-modal__recipient-row--selected]="isRecipientSelected(option)"
          (click)="toggleRecipient(option)">
          <div class="chat-share-modal__recipient">
            <app-thumbnail
              [imgSrc]="recipientAvatar(option) | mediaObject:{defaultImageType: 'avatar'}"
              [circle]="true"
              size="sm">
            </app-thumbnail>
            <span class="chat-share-modal__recipient-label">{{ option.alias }}</span>
          </div>
          <div class="chat-share-modal__recipient-checkbox" (click)="$event.stopPropagation()">
            <p-checkbox
              [binary]="true"
              [ngModel]="isRecipientSelected(option)"
              (onChange)="toggleRecipient(option)">
            </p-checkbox>
          </div>
        </button>

        <div class="chat-share-modal__loading" *ngIf="loadingInitialRecipients || loadingMoreRecipients">
          <app-spinner [inline]="true" size="28px"></app-spinner>
        </div>
      </div>
    </ng-template>

    <div class="chat-share-modal__hint" *ngIf="shouldShowRecipientQueryEmptyState">
      {{ 'common.no_results' | translate }}
    </div>
  </div>

  <div class="chat-share-modal__selected" *ngIf="shouldShowSelectedRecipients">
    <p-chip
      *ngFor="let recipient of selectedRecipients"
      [label]="recipient.alias"
      [image]="recipientAvatar(recipient) | mediaObject:{defaultImageType: 'avatar'}"
      [removable]="true"
      (onRemove)="removeRecipient(recipient)">
    </p-chip>
  </div>

  <div class="chat-share-modal__field">
    <label>{{ 'shared.share.chat.message' | translate }}</label>
    <app-social-input
      #messageInput
      [label]="'shared.share.chat.message_placeholder' | translate"
      [chatMode]="true"
      [allowEmptySubmit]="true"
      [submitDisabled]="!selectedRecipients.length || submitting"
      [loading]="submitting"
      (submitted)="onMessageSubmit($event)">
    </app-social-input>
  </div>

  <div class="chat-share-modal__empty" *ngIf="shouldShowEmptyRecipientsState">
    {{ 'shared.share.chat.empty' | translate }}
  </div>

  <div class="chat-share-modal__actions">
    <button
      pButton
      type="button"
      [rounded]="true"
      [label]="'shared.share.chat.submit' | translate"
      [disabled]="!selectedRecipients.length || submitting"
      [loading]="submitting"
      (click)="submit()" loadingIcon="app-loading-ring">
    </button>
  </div>
</div>
